module.exports = __webpack_public_path__ + "static/img/aff3.fd01954e.png";